import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';
import { Button } from '../ui/Button';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    q: '¿Necesito saber cocinar para usar el sistema?',
    a: 'Para nada. Las recetas están diseñadas para personas que nunca cocinaron para sus mascotas. Si podés hervir agua y mezclar ingredientes, podés hacer cualquier receta del sistema.'
  }, {
    q: '¿Funciona para perros y gatos de todas las razas y edades?',
    a: 'Sí. Hay recetas y planes para cachorros, adultos y seniors. Para razas pequeñas, medianas y grandes. Para gatos de interior y exterior. Las porciones se ajustan por peso con una tabla muy simple.'
  }, {
    q: '¿Qué pasa si mi mascota tiene alguna condición médica especial?',
    a: 'El sistema incluye planes específicos para condiciones como diabetes, problemas renales, alergias y obesidad. Igual, siempre recomendamos consultar con tu veterinario para condiciones graves.'
  }, {
    q: '¿Cómo accedo después de comprar?',
    a: 'Inmediatamente. En cuanto confirmás el pago, recibís un email con acceso a la plataforma digital. En menos de 5 minutos ya podés estar leyendo las primeras recetas.'
  }, {
    q: '¿Realmente voy a ahorrar dinero?',
    a: 'El promedio de nuestros usuarios ahorra entre $8.000 y $15.000 por mes comparado con alimentos comerciales equivalentes en calidad nutricional. El sistema se paga solo en el primer mes.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="py-12 px-4 bg-cream border-t border-gray-200" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <div className="text-center mb-8" data-id="element-36">
          <h2 className="text-4xl md:text-5xl font-black text-forest-green flex items-center justify-center gap-3 font-serif" data-id="element-37">
            <HelpCircle className="w-10 h-10 text-gold" data-id="element-38" />
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-39">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-white rounded-xl shadow-sm border transition-all duration-300 overflow-hidden ${isOpen ? 'border-gold border-l-4' : 'border-gray-200'}`} data-id="element-40">
                <button onClick={() => toggleFaq(idx)} className="w-full text-left p-5 md:p-6 flex justify-between items-center gap-4 focus:outline-none focus-visible:bg-gray-50" aria-expanded={isOpen} data-id="element-41">
                  <h3 className="text-lg md:text-xl font-black text-forest-green pr-2" data-id="element-42">
                    {faq.q}
                  </h3>
                  <ChevronDown className={`w-6 h-6 text-gold flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-43" />
                </button>

                <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-44">
                  <div className="overflow-hidden" data-id="element-45">
                    <div className="px-5 md:px-6 pb-5 md:pb-6 text-base md:text-lg text-gray-700 leading-relaxed border-t border-gray-100 pt-4 font-medium" data-id="element-46">
                      {faq.a}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-12 text-center" data-id="element-47">
          <Button fullWidth className="md:w-auto shadow-glow" data-id="element-48">
            QUIERO TRANSFORMAR A MI MASCOTA AHORA
          </Button>
          <p className="mt-4 text-sm text-gray-600 font-bold tracking-wide" data-id="element-49">
            Acceso instantáneo · Garantía de 30 días
          </p>
        </div>
      </div>
    </section>;
}